module.exports = "/_next/static/images/virtual-card-grey-fa93e25deed74ad60ce6a60d2b9902bf.svg";